shadow$provide[432] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform vec4 repeatModulus;

vec4 getRepeatXYZW(vec4 xyzw) {
  return mod(xyzw + .5, repeatModulus) - .5;
}
`;

};